import React from "react";

/**
 * Same as React.useEffect, but this one will not be triggered on the first render.
 */
export const useLazyEffect = (callback, deps) => {
  const initialized = React.useRef(false);

  React.useEffect(() => {
    if (initialized.current) {
      callback();
    } else {
      initialized.current = true;
    }
    // eslint-disable-next-line
  }, deps);
};
